import React from "react";
import { Modal, Form, Input, Button, Space, Select, Switch } from "antd";
import { CategoryModalProps } from "../../types";

const { Option } = Select;

const CategoryModal: React.FC<CategoryModalProps> = ({
  visible,
  onCancel,
  onFinish,
  editingRecord,
  form,
}) => {
  return (
    <Modal
      title={editingRecord ? "Chỉnh sửa danh mục" : "Thêm danh mục"}
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={600}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={editingRecord || {}}
      >
        <Form.Item
          name="name"
          label="Tên"
          rules={[
            {
              required: true,
              message: "Tên không được để trống",
            },
          ]}
        >
          <Input placeholder="Tên danh mục" />
        </Form.Item>

        <Form.Item
          name="isHidden"
          label="Trạng thái"
          valuePropName="checked"
          getValueProps={(value) => ({ checked: !value })}
          getValueFromEvent={(checked) => !checked}
          initialValue={editingRecord?.isHidden || false}
        >
          <Switch defaultChecked />
        </Form.Item>

        <Form.Item>
          <Space>
            <Button type="primary" htmlType="submit">
              Lưu
            </Button>
            <Button onClick={onCancel}>Huỷ</Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CategoryModal;
